/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import { isAdhocColumn, isPhysicalColumn } from '@superset-ui/core';
import type { ColumnMeta, ControlPanelsContainerProps } from '../types';

export default function displayTimeRelatedControls({
  controls,
}: ControlPanelsContainerProps) {
  const xAxisColumns = Array.isArray(controls?.x_axis_columns?.value)
    ? controls.x_axis_columns.value
    : [];
  const xAxisControl = xAxisColumns.length > 0 ? controls?.x_axis_columns : controls?.x_axis;

  if (!xAxisControl) {
    return true;
  }

  const xAxisValue = Array.isArray(xAxisControl.value)
    ? xAxisControl.value[0]
    : xAxisControl.value;
  if (isAdhocColumn(xAxisValue)) {
    return true;
  }
  if (isPhysicalColumn(xAxisValue)) {
    return !!(xAxisControl?.options ?? []).find(
      (col: ColumnMeta) => col?.column_name === xAxisValue,
    )?.is_dttm;
  }
  return false;
}
